import { api } from '../../../lib/api'

export const GET_REPORTS_REQUEST = 'GET_REPORTS_REQUEST'
export const GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS'
export const GET_REPORTS_FAILED = 'GET_REPORTS_FAILED'

export const getReports = function () {
  return function (dispatch) {
    dispatch({
      type: GET_REPORTS_REQUEST
    })
    api.getReports().then(getReportsResponse => {
      dispatch({
        type: GET_REPORTS_SUCCESS,
        payload: getReportsResponse
      })

    }).catch(error => {
      dispatch({
        type: GET_REPORTS_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/message/get-reports.js